/**
 * **저장 행의 파일 칸 — 서버 교체 입구의 어휘 한 곳.** 의존성 없는 순수 모듈이다(단위 테스트가 node 에서 그대로 읽는다).
 *
 * 서버의 파일 교체 입구(`BucketFileUtil.replaceStored`, 판정 `StoredFileChange.planOf` — R-K 가 정한 한 규칙)는 요청의 파일 칸(`…File`)
 * 값을 셋으로 읽는다:
 *
 * - 새 파일(base64 데이터 URL) → 저장 행의 파일을 바꾼다.
 * - 지움 표시 [FILE_DELETE_MARK] → 저장 행의 파일을 지우고 칸을 비운다.
 * - 그 밖(화면이 되보낸 경로·**빈 값**) → 저장 행의 값 **그대로**.
 *
 * 그래서 「이미지 삭제」는 파일 칸을 비우는 것이 아니라 지움 표시를 싣는 것이다 — 비우면 저장 성공 뒤에도 이미지가 남는다(R-L 서버 리뷰
 * G2, 이벤트 관리). 화면마다 이 문자열과 「이미지가 있는가」를 따로 적지 않는다: 매장 이미지(`StoreInfoFormPanel`)·플레이스 썸네일·광고
 * 이미지(`PlaceListView`)·이벤트 이미지(`EventListView`)가 이 두 함수를 쓴다.
 */

/** 지움 표시 — 서버 `StoredFileChange.DELETE_MARK` 와 같은 문자열 */
export const FILE_DELETE_MARK = '__DELETE__'

/** 파일이 없는 칸의 값 — 서버 `StoredFileChange.NO_FILE` 과 같은 값(이 칸들은 NULL 이 아니라 빈 문자열을 쓴다) */
export const NO_FILE = ''

/**
 * **이미지 삭제의 폼 패치** — 경로 칸(`pathKey`, 미리보기·표시용)은 비우고 파일 칸(`fileKey`, 서버로 가는 값)에 지움 표시를 싣는다.
 * 새 객체를 돌려준다 — 폼에 앉히는 것은 부르는 쪽(경계)이다. 순수.
 *
 * @param {string} pathKey 저장 경로 칸(예: `img`·`storeImg`·`thumbnailUrl`)
 * @param {string} fileKey 파일 칸(예: `imgFile`·`storeImgFile`·`thumbnailFile`)
 * @returns {Object<string, string>}
 */
export function fileRemoval(pathKey, fileKey) {
  return { [pathKey]: NO_FILE, [fileKey]: FILE_DELETE_MARK }
}

/**
 * **이 칸에 그릴 이미지가 있는가**(미리보기·삭제 버튼) — 경로나 새 파일이 있고, 지움 표시가 아니면. 순수.
 *
 * @param {?object} form
 * @param {string} pathKey
 * @param {string} fileKey
 */
export function hasStoredImage(form, pathKey, fileKey) {
  const value = form || {}

  return !!(value[pathKey] || value[fileKey]) && value[fileKey] !== FILE_DELETE_MARK
}
